// extracted by mini-css-extract-plugin
export default {"container":"noti_container__z9os+","main_ok":"noti_main_ok__hzwQ1","main_error":"noti_main_error__cCzYA"};